module.exports = __webpack_public_path__ + "static/media/18.e306374e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/18.png
// module id = 1515
// module chunks = 0